import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdChartsDataContext } from './hooks/useHouseholdChartsDataContext';

export const RoomsPerHouse = () => {
    const { chartData } = useHouseholdChartsDataContext();


    return (
        <SimpleBars
            title={'Quantidade de Cômodos no Domicílio'}
            horizontal={true}
            subtitles={chartData?.roomsPerHouse?.map((item) => item.description)}
            values={chartData?.roomsPerHouse?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
